// @ts-check
import { useCallback } from 'react';
import useEventListener from '../useEventListener';

const useEscape = (callback, disabled = false) => {
  if (disabled) return;

  if (typeof callback !== 'function') {
    throw new Error('useEscape: callback is not a function');
  }

  const ESCAPE_KEY = 27;

  const handleEscapePress = useCallback((event) => {
    if (event.keyCode === ESCAPE_KEY) {
      callback(event);
    }
  }, []);

  useEventListener('keydown', handleEscapePress);
};

/* @component */
export default useEscape;
